module.exports = __webpack_public_path__ + "static/media/face.fcce37f2.jpg";